import { render, staticRenderFns } from "./uploadCV.vue?vue&type=template&id=fdbba2b0"
import script from "./uploadCV.vue?vue&type=script&lang=js"
export * from "./uploadCV.vue?vue&type=script&lang=js"
import style0 from "./uploadCV.vue?vue&type=style&index=0&id=fdbba2b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports